module.exports = __webpack_public_path__ + "static/media/aditya_arun_design.880bf38e.jpg";